import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * Persona schema embedded within scenarios.
 * @since 1.0.0
 */
export const PersonaSchema = Schema.Struct({
  name: Schema.String,
  description: Schema.String,
});

/**
 * Scenario schema with embedded persona.
 * @since 1.0.0
 */
export const ScenarioSchema = Schema.Struct({
  id: Schema.String,
  title: Schema.String,
  setting: Schema.String,
  persona: PersonaSchema,
});

export type Scenario = Schema.Schema.Type<typeof ScenarioSchema>;
export type Persona = Schema.Schema.Type<typeof PersonaSchema>;

/**
 * Quest status enum.
 * - draft: Quest is being built through LLM conversation
 * - published: Quest is complete and available for use
 * - archived: Quest is no longer active
 * @since 1.0.0
 */
export const QuestStatus = Schema.Literal("draft", "published", "archived");
export type QuestStatus = Schema.Schema.Type<typeof QuestStatus>;

/**
 * Quest model for flirt quest builder.
 *
 * Stores quest configuration including foundation (situation/theme)
 * and scenarios with embedded personas.
 *
 * @since 1.0.0
 */
export class Quest extends Model.Class<Quest>("Quest")({
  id: Model.Generated(Schema.String),
  personId: Schema.NullOr(Schema.String),
  conversationId: Schema.NullOr(Schema.String),
  title: Schema.NullOr(Schema.String),
  situation: Schema.String,
  theme: Schema.String,
  scenarios: Schema.Array(ScenarioSchema),
  status: Schema.optionalWith(QuestStatus, { default: () => "draft" as const }),
  createdAt: Model.DateTimeInsertFromDate,
  updatedAt: Model.DateTimeUpdateFromDate,
}) {}
